// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-3f697393]{height:50px}[dir] div[data-v-3f697393]{margin:5px;cursor:pointer}.color-picker[data-v-3f697393]{width:100%;height:40px}[dir] .color-picker[data-v-3f697393]{margin-bottom:10px}.color-picker input[type=color][data-v-3f697393]{height:100%}[dir] .color-picker input[type=color][data-v-3f697393]{padding:0;border:none;border-radius:4px}", ""]);
// Exports
module.exports = exports;
